












import { Vue, Component, Prop } from 'vue-property-decorator';
import { pdfState } from '@/store/modules/pdf-state';

@Component
export default class PdfViewer extends Vue {
  url: string = 'pdfjs/web/viewer.html?file=';

  get file(): string {
    return pdfState.file;
  }

  async mounted() {
    const { pdfParams } = this.$route.params;
    console.log(pdfParams);

    await pdfState.download();
    const pdfUrl = pdfState.file;
    this.url = `pdfjs/web/viewer.html?file=${pdfUrl}#${pdfParams}`;
  }
}
